<div role="contentinfo" class="footer bg-primary text-white text-center">
  <div class="footer-quicklinks bg-secondary w-100"></div>
  <div class="footer-text bg-primary text-white d-flex align-items-center justify-content-center w-100 h-100">
    <div class="footer-content">
      <img alt="" class="footer-logo mb-2" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
      <p class="font-size-12 text-center footer-rights mb-0" [innerHTML]="'nav.club.rights' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
